module.exports = __webpack_public_path__ + "05453fa319e360a1e9e5209506c73fcf.pdf";